import * as React from 'react'
import { View, Text } from 'react-native'
import styled from '@theme/styled-components'

import useI18n from '@i18n/useI18n'
import useReducer from '@store/useReducer'
import * as SocieteStore from '@store/societe/societe'

const TAG_HEIGHT = 24

interface Props {
  user: UserResponse
}

const UserCard = ({ user }: Props) => {
  const i18n = useI18n()
  const services = useReducer(SocieteStore.store, (s) => s.services)

  const service = user.societeId ? services.find((s) => s.id === user.societeId) : undefined

  return (
    <MainContainer>
      <TopContainer>
        <Name numberOfLines={1} ellipsizeMode="tail">{`${user.prenom} ${user.nom}`}</Name>

        <Info numberOfLines={1} ellipsizeMode="tail">
          {service ? service.nameSociete : user.societeId ? i18n.t('components.userCard.unknownService') : ''}
        </Info>
      </TopContainer>

      <BottomContainer>
        <Tags>
          <Tag>{user.typeUtilisateur}</Tag>
          {!user.enabled && <Tag isInactive>{i18n.t('components.userCard.inactive')}</Tag>}
        </Tags>

        <Info numberOfLines={1} ellipsizeMode="tail">
          {user.numeroTelephonePortable || i18n.t('components.userCard.unknownPhone')}
        </Info>

        <Info numberOfLines={1} ellipsizeMode="tail">
          {user.email}
        </Info>
      </BottomContainer>
    </MainContainer>
  )
}

export default UserCard

const MainContainer = styled(View)`
  ${(props) => props.theme.breakpoint !== 'phone' && `width: 360px;`}
  height: 200px;
  ${(props) => props.theme.constants.shadow};
  border-radius: 8px;
  background-color: ${(props) => props.theme.colors.incident};
  overflow: hidden;
`

const TopContainer = styled(View)`
  padding: 16px 24px;
  background-color: ${(props) => props.theme.colors.background};
  height: 90px;
`

const Name = styled(Text)`
  ${(props) => props.theme.fonts.Headline};
  padding-bottom: 8px;
`

const Info = styled(Text)`
  ${(props) => props.theme.fonts.Option};
  margin-bottom: 8px;
`

const BottomContainer = styled(View)`
  padding: 0 24px 16px;
  margin-top: -${TAG_HEIGHT / 2}px;
`

const Tags = styled(View)`
  flex-direction: row;
  justify-content: space-between;
`

const Tag = styled(Text)<{ isInactive?: boolean }>`
  ${(props) => props.theme.fonts.Caption1};
  border-radius: 8px;
  padding: 4px 8px;
  height: ${TAG_HEIGHT}px;
  color: ${(props) => props.theme.colors.background};
  background-color: ${(props) => (props.isInactive ? props.theme.colors.negate : props.theme.colors.primary)};
  margin-bottom: 16px;
`
